import React from 'react'
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
import { AlertsInformativos } from '../../components/generics/AlertsInformativos'
import { alertInformativo } from '../../commons/texts'
import { Divider } from '@mui/material'

export const Cotizaciones = () => {
  return (
    
    <>
       
         <BreadCrumbsAndTitle
            title="Cotizaciones"
            mainModule="ordenes de servicio"
            parent="Cotizaciones"
            action=""
        />
        <AlertsInformativos
            type="info"
            title="info"
            content={alertInformativo.cotizaciones}
        />
        <Divider sx={{ marginBottom: 5 }} />
     
    </>
  )
}
